import React from "react";

import * as firebase from "firebase/app";
import "firebase/firestore";

import { useDocumentData } from "react-firebase-hooks/firestore";
import { useHistory } from "react-router-dom";

const JoinChat = (props) => {
  const [chatInfo] = useDocumentData(
    firebase.firestore().doc(`chats/${props.id_chat}`)
  );

  let history = useHistory();
  if (chatInfo) {
    let usersTab = chatInfo.users;

    let usersTabBoolean = true;
    usersTab.forEach((el) => {
      if (el.id === props.userId) {
        usersTabBoolean = false;
      }
    });

    if (usersTabBoolean) {
      usersTab.push({
        id: props.userId,
        pseudo: props.valueUserInfo.pseudo,
      });

      firebase.firestore().doc(`chats/${props.id_chat}`).update({
        users: usersTab,
      });

      const increment = firebase.firestore.FieldValue.increment(1);
      firebase.firestore().doc(`posts/${props.postId}`).update({
        user_nbr: increment,
      });
    }

    if (props.valueUserInfo.mates) {
      let chatTab = props.valueUserInfo.mates;
      let chatTabBoolean = true;

      if (chatTab) {
        chatTab.forEach((el) => {
          if (el === props.id_chat) {
            chatTabBoolean = false;
          }
        });
      }

      if (chatTabBoolean) {
        chatTab.push(props.id_chat);

        firebase.firestore().doc(`users/${props.userId}`).update({
          mates: chatTab,
        });
      }
    } else {
      firebase
        .firestore()
        .doc(`users/${props.userId}`)
        .update({
          mates: [props.id_chat],
        });
    }

    history.push(`/app/chat/${props.id_chat}`);
  }

  return <></>;
};

export default JoinChat;
